import React from 'react';
import { Stack, Typography, CircularProgress } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

export const VideoProcessing = () => (
  <Stack
    data-testid="events-overlay-video-processing"
    direction="column"
    alignItems="center"
    justifyContent="center"
    spacing={2}
  >
    <CircularProgress size={60} sx={{ color: colors.grey[400] }} />
    <Stack spacing={1} alignItems="center" direction="column">
      <Typography variant="h6" textAlign="center" color={colors.grey[400]}>
        Video is being processed
      </Typography>
      <Typography variant="body2" textAlign="center" color={colors.grey[500]}>
        Please wait while the video is being processed
      </Typography>
    </Stack>
  </Stack>
);
